<template>
  <div class="water">
    <div class="zhiwei">
      <div class="title">
        <titleCard title='CKD Integrated Management System'></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft">
          Personalized, standardized and systematic self-management for CKD patients to achieve the whole course coverage for CKD patients, thus improving patient compliance and promoting continuous patients health management.</div>
        <div class="right animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/News/huanzhe/huanzhe1.png" alt="">
        </div>
      </div>
      <!-- 核心功能 -->
      <div class="hexin">
        <div class="title">
          <titleCard title="Core Functions"></titleCard>
          <div class="title-txt">Achieve efficient information transmission, improve after-sales service quality, and achieve diversified and customized service</div>
        </div>
        <div class="mypcbox">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/huanzhe/huanzhe2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/huanzhe/icon1.webp" alt="">
              <h3>Follow-Up Management</h3>
              <p>cover the whole life of patients with <br>customized follow-up plan</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/huanzhe/icon2.webp" alt="">
              <h3>Warning System</h3>
              <p> monitor indicators, real-time abnormal data, <br>to notify the doctor and patient for timely treatment</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/huanzhe/huanzhe3.webp" alt=""></div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/huanzhe/huanzhe4.webp" alt=""></div>
            <div class="txt txt2 animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/huanzhe/icon3.webp" alt="">
              <h3>Data Recording</h3>
              <p>systematic management and recording<br> of patient's demographics and related <br>treatment history</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/huanzhe/icon4.webp" alt="">
              <h3>Department Education</h3>
              <p>Integrated CKD management of right <br>medication, diet, exercise and other <br>therapeutic measures at different stages</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/huanzhe/huanzhe5.webp" alt=""></div>
          </div>
        </div>
        <div class="myiosbox">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon1.webp" alt="">
              <div class="text">
                <h3>Follow-Up Management</h3>
                <p>cover the whole life of patients with customized follow-up plan</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe3.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon2.webp" alt="">
              <div class="text">
                <h3>Warning System</h3>
                <p>monitor indicators, real-time abnormal data, to notify the doctor and patient for timely treatment</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe4.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon3.webp" alt="">
              <div class="text">
                <h3>Data Recording</h3>
                <p>systematic management and recording of patient's demographics and related treatment history</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/huanzhe/huanzhe5.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/huanzhe/icon4.webp" alt="">
              <div class="text">
                <h3>Department Education</h3>
                <p>Integrated CKD management of right medication, diet, exercise and other</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 慢性肾病一体化分级管理 -->
      <div class="ckd animate__animated wow animate__fadeInUp">
        <div class="title">
          <titleCard title=" exercise and other therapeutic measures at different stages"></titleCard>
        </div>
        <div class="contentbox">
          <div class="leftbox">
            <div class="txtbox">
              <h3>Personalized Treatment</h3>
              <p>customized, full-process, and individualized behavioral interventions and disease management programs</p>
            </div>
            <div class="txtbox">
              <h3>Medical Partnerships</h3>
              <p>leverage medical institutions of different levels to effectively manage patients from a global view</p>
            </div>
            <div class="txtbox mnone">
              <h3>Full-course Monitoring</h3>
              <p>standardized follow-up management, timely treatment when abnormal indicators be warned (online guidance, offline follow-up, referral treatment)</p>
            </div>
          </div>
          <div class="rightbox">
            <img src="../../assets/image/News/huanzhe/huanzhe6.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <footerCard name='Mr Wu' phone='138-1097-5144'></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card2.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.water {
  .zhiwei {
    .title {
      padding: 1rem 0 1.4316rem 0;
      @media screen and (max-width: 540px) {
        padding: 37px 0 54px 0;
      }
    }
    .content {
      height: 4.5053rem;
      display: flex;
      align-items: center;
      margin-bottom: 2.2632rem;
      @media screen and (max-width: 540px) {
        display: block;
        box-sizing: border-box;
        padding: 0 26px;
        height: 100%;
      }
      .left {
        width: 7.2211rem;
        margin-right: 1.0947rem;
        margin-left: 2.3895rem;
        color: #272b2d;
        line-height: 0.4421rem;
        font-size: 0.2526rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          font-size: 15px;
          line-height: 26px;
          margin: 0;
        }
      }
      .right {
        width: 6.2526rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          height: 240px;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .hexin {
      .title {
        padding-bottom: 0.7895rem;
        .title-txt {
          text-align: center;
          width: 70%;
          margin: 0 auto;
          color: #666666;
          font-size: 0.2526rem;
          padding: 22px 0 40px 0;
          @media screen and (max-width: 540px) {
          font-size: 13px;
        }
        }
      }
      .titletxt {
        color: #666666;
        text-align: center;
        font-size: 0.2526rem;
        line-height: 0.4211rem;
        padding-bottom: 2.1053rem;
      }
      .mypcbox {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .mybox {
          display: flex;
          padding: 0 1.6842rem;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.0526rem;
          .pic {
            width: 50%;
            height: 5.2632rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 1.1158rem;
            box-sizing: border-box;
            width: 50%;
            img {
              display: block;
              width: 0.5053rem;
              height: 0.4737rem;
            }
            h3 {
              margin: 0;
              padding: 0.3263rem 0 0.4211rem 0;
              color: #333333;
              font-size: 0.2947rem;
            }
            p {
              font-size: 0.2526rem;
              color: #333333;
              line-height: 0.4211rem;
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
      .myiosbox {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
        }
        margin-bottom: 50px;
        .mybox {
          padding: 0 14px;
          align-items: center;
          justify-content: center;
          margin-bottom: 36px;
          .pic {
            width: 100%;
            height: 240px;
            margin-bottom: 23px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 5px;
            box-sizing: border-box;
            width: 100%;
            display: flex;
            align-items: center;
            img {
              display: block;
              width: 30px;
              height: 28px;
              padding-right: 18px;
            }
            .text {
              h3 {
                margin: 0;
                padding: 0.3263rem 0 0.4211rem 0;
                color: #333333;
                font-size: 17px;
              }
              p {
                font-size: 15px;
                color: #333333;
                padding-right: 50px;
                line-height: 25px;
              }
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
    }
    .ckd {
      .title {
        padding: 0.4211rem 0 1.3684rem 0;
        @media screen and (max-width: 540px) {
          padding-bottom: 45px;
        }
      }
      .contentbox {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1.2632rem;
        height: 5.7895rem;
        @media screen and (max-width: 540px) {
          display: block;
          height: 100%;
        }
        .leftbox {
          width: 50%;
          padding-left: 1.7053rem;
          padding-right: 1.7895rem;
          box-sizing: border-box;
          @media screen and (max-width: 540px) {
            width: 100%;
            padding: 0 22px;
          }
          .txtbox {
            margin-bottom: 0.6316rem;
             @media screen and (max-width: 540px) {
                margin-bottom: 35px;
              }
            h3 {
              margin: 0;
              color: #0ca6eb;
              font-size: 0.2947rem;
              padding-bottom: 0.2105rem;
              @media screen and (max-width: 540px) {
                font-size: 16px;
              }
            }
            p {
              color: #333333;
              font-size: 0.2421rem;
              line-height: 0.5263rem;
              @media screen and (max-width: 540px) {
                font-size: 14px;
                line-height: 25px;
              }
            }
          }
          .mnone {
            margin: 0;
          }
        }
        .rightbox {
          width: 50%;
          height: 100%;
          @media screen and (max-width: 540px) {
            width: 100%;
            padding: 0 22px;
            box-sizing: border-box;
            margin-top: 30px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
